export const RECONNECTION_ATTEMPTS = 30;
export const BACKGROUND_RECONNECTION_ATTEMPTS = 3;